import { useMemo, useState } from "react";

function compareValues(left, right) {
  if (left === right) return 0;
  if (left === null || left === undefined || left === "") return 1;
  if (right === null || right === undefined || right === "") return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), "id-ID", {
    numeric: true,
    sensitivity: "base",
  });
}

export function useSortableData(
  items,
  initialKey = null,
  initialDirection = "asc",
) {
  const [sort, setSort] = useState({
    key: initialKey,
    direction: initialDirection,
  });

  const sortedItems = useMemo(() => {
    if (!sort.key) return items;
    const direction = sort.direction === "asc" ? 1 : -1;
    return items
      .map((item, index) => ({ item, index }))
      .sort((left, right) => {
        const result = compareValues(
          left.item[sort.key],
          right.item[sort.key],
        );
        return result === 0
          ? left.index - right.index
          : result * direction;
      })
      .map(({ item }) => item);
  }, [items, sort]);

  function toggleSort(key) {
    setSort((current) => ({
      key,
      direction:
        current.key === key && current.direction === "asc" ? "desc" : "asc",
    }));
  }

  return { sortedItems, sort, toggleSort };
}
